// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
        intro.onclick = (e) => {
          if (content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            accordions.forEach((accordion) => closeAccordion(accordion));
            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
    }
  });   
}
// accordions js end
(function() {
  faq_taggol();

  const header_operlay = document.querySelector("[data-banner-header-overlay]");
  if(header_operlay){
    document.body.classList.add('header-overlay');
  }   

})();

const heading = document.querySelector('.table-contents .heading');
const content = document.querySelector('.table-contents .content');

if (heading && content) {
  heading.addEventListener('click', () => {
    content.classList.toggle('active');
  });
}

const listItems = document.querySelectorAll('.table-contents ul.menu li');

if (listItems.length && content) {
  listItems.forEach((li) => {
    li.addEventListener('click', () => {
      content.classList.remove('active');
    });
  });
}





// media swiper only mobile view 

  if (window.matchMedia) {
  const mq = window.matchMedia("(min-width: 990px)");
  mq.addListener(handleWidthChange);
  handleWidthChange(mq);
}

function handleWidthChange(mq) {
  const sliderEl_div = document.querySelector('.product-main-section [data-main-pdp-swiper]');
  if (!sliderEl_div) return; // exit if no slider on this page

  const sliderEl = document.querySelector('.product-main-section [data-pdp-main-slider]');
  if (!sliderEl) return;

  const optionsAttr = sliderEl.getAttribute('data-slider-options');

  if (mq.matches) {
    // Desktop: destroy swiper if exists
    if (sliderEl_div.swiper) {
      sliderEl_div.swiper.destroy(true, true);
    }
  } else {
    // Mobile: initialize swiper if not already initialized
    if (!sliderEl_div.swiper) {
      if (optionsAttr) {
        const options = JSON.parse(optionsAttr);
        new Swiper(sliderEl_div, options);
      }
    }
  }
}

const menuItems = document.querySelectorAll('.mega-menu__list li a');

menuItems.forEach(item => {
  item.addEventListener('mouseenter', () => {

    // Active class on menu items
    menuItems.forEach(i => i.classList.remove('active'));
    item.classList.add('active');

    const title = item.getAttribute('data-title');

    // 🔥 IMPORTANT: current mega menu wrapper
    const megaMenu = item.closest('.mega-menu');

    if (!megaMenu) return;

    const productBlocks = megaMenu.querySelectorAll(
      '.mega-menu__main-product-wrepper .menu-product-list'
    );

    productBlocks.forEach(block => {
      const contentAttr = block.getAttribute('data-content');

      if (contentAttr === title) {
        block.classList.add('active');
      } else {
        block.classList.remove('active');
      }
    });
  });
});


const tabs = document.querySelectorAll('.tabs.custom-faq-tab ul li');

if (tabs.length > 0) {
  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      let target = this.getAttribute('data-href');

      // remove #
      target = target.replace('#', '');

      // Remove active class
      tabs.forEach(li => li.classList.remove('active'));
      document
        .querySelectorAll('.grid__item.tab-faq-section-inner .panel')
        .forEach(panel => panel.classList.remove('active'));

      this.classList.add('active');

      // Match panel by ID
      const matchedPanel = document.getElementById(target);

      if (matchedPanel) {
        matchedPanel.classList.add('active');
      }
    });
  });
}

